
import request from "../utils/request";


export function cmsVersionList(data) {
    return request({
        url: "/version/cmsVersionList",
        data: data,
    });
}

export function addVersion(data) {
    return request({
        url: "/version/addVersion",
        data: data,
    });
}

export function updateVersion(data) {
    return request({
        url: "/version/updateVersion",
        data: data,
    });
}